export enum ServerErrorStatus {
	UNAUTHORIZED = 401,
	FORBIDDEN = 403,
	SERVER_ERROR = 500,
}
